import Modal from "react-modal";
import { Container, Contents, Title } from "./styled";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { useEffect, useState } from 'react'
import { toast } from "react-toastify";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "540px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "transparent",
        padding: "0px",
        margin: "0px",
        borderRadius: "8px",
        border: "none"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    },
};




const ModalUpdateLicenses = (props) => {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.reducerLanguage);
    const { id } = useParams();
    const reducerUpdateLicenses = useSelector((state) => state.reducerUpdateLicenses);

    const [name, setName] = useState(props.item.name)


    const closeModal = () => {
        //props.handleClick()

        setTimeout(() => {
            props.setVisible(false)
            //props.goSearch()
            //props.setDataModalDeleteCompleted([])
        }, 0);
    }

    useEffect(() => {
        
    }, [])


    const update = () => {
        dispatch({ type: "SAGA_UPDATE_LICENSES", payload: { name: name, id: props.item.id } })
        //closeModal()
    }

    useEffect(() => {
        console.log("reducerUpdateLicenses", reducerUpdateLicenses)
        if (reducerUpdateLicenses.loading == false && reducerUpdateLicenses.error == false && reducerUpdateLicenses.data.length == 0) {
        } else {
            console.log("reducerUpdateLicenses", reducerUpdateLicenses)
            const id = "reducerUpdateLicenses"
            if (reducerUpdateLicenses.loading) {
                toast.loading("Aguarde..", { toastId: id })
            } else {
                if (reducerUpdateLicenses.error) toast.update(id, { render: "Erro ao atualizar licença", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Licença atualizada com sucesso", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    props.goSearch()
                    closeModal()
                    //props.setVisible(false)
                    //goSearch()
                    dispatch({ type: "LICENSES_UPDATE_RESET" })
                }
            }
        }
    }, [reducerUpdateLicenses])

    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { }}


        >

            <Container>
                <Title>
                    <div>
                        <label>Excuindo arquivos</label>
                        <XMarkIcon onClick={() => { closeModal() }} style={{ cursor: "pointer" }} width={20} />
                    </div>
                    <label >
                        Aguarde enquanto excluímos os arquivos selecionados.
                    </label>
                </Title>
                <Contents>
                    <div>
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            Nome
                        </label>
                        <div className="mt-2">
                            <input
                                id="name"
                                name="name"
                                type="text"
                                placeholder=""
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#111827] sm:text-sm/6"
                            />
                        </div>
                    </div>
                    
                    <div className="flex shrink-0 justify-end px-4 py-4">
                        <button
                            type="button"
                            onClick={() => { closeModal() }}
                            className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                        >
                            Cancelar
                        </button>
                        <button
                        onClick={() => { update() }}
                            type="submit"
                            className="ml-4 inline-flex justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-500"
                        >
                            Salvar
                        </button>
                    </div>
                </Contents>
            </Container>

        </Modal >
    )
}

export default ModalUpdateLicenses

